/**
 * «این‌ها یکی هستند» در کارتِ «چند عکسی» (WHOSUP-244، مایگریشن 0151).
 *
 * منطقِ خالص، جدا از رابط، تا با `npm test` سنجیده شود:
 *   • عکس‌های یک رویداد چطور دسته می‌شوند (هم‌گروه‌ها یک دسته، به ترتیبِ
 *     اولین حضور در فهرست)؛
 *   • تیک‌های ادمین چطور به ورودیِ `admin_set_same_photos` تبدیل می‌شوند.
 *
 * تیک روی **دسته** می‌خورد، نه روی تک‌آدرس: یک آبشارِ «یکی هستند» یک عکس
 * است، و تیک‌زدنش یعنی همه‌ی آدرس‌هایش — تا بشود عکسِ سومی را به گروهی که
 * از قبل هست اضافه کرد.
 */

export interface GroupablePhoto {
  url: string;
  group: string | null;
}

/** کلیدِ دسته: شناسه‌ی گروه، یا خودِ آدرس برای عکسِ تنها. */
export const photoKey = (p: GroupablePhoto): string => p.group ?? `url:${p.url}`;

/** عکس‌های یک رویداد، دسته‌شده؛ ترتیب همان ترتیبِ فهرست است. */
export function clusterPhotos<T extends GroupablePhoto>(images: T[]): T[][] {
  const byKey = new Map<string, T[]>();
  for (const img of images) {
    const k = photoKey(img);
    const c = byKey.get(k);
    if (c) c.push(img); else byKey.set(k, [img]);
  }
  return [...byKey.values()];
}

export interface SamePhotosPayload {
  /** ورودیِ `admin_set_same_photos`، یک عضو برای هر رویداد. */
  groups: { event_id: string; urls: string[] }[];
  /** رویدادهایی که فقط یک دسته تیک خورده — کنار گذاشته می‌شوند. */
  lonely: number;
}

/**
 * `picked`: برای هر رویداد، کلیدِ دسته‌های تیک‌خورده. فقط رویدادی که دو
 * دسته یا بیشتر تیک خورده چیزی برای ثبت دارد؛ یکی را با خودش یکی کردن
 * معنایی ندارد.
 */
export function samePhotosPayload(
  samples: { id: string; images: GroupablePhoto[] }[],
  picked: Record<string, string[]>,
): SamePhotosPayload {
  const groups: SamePhotosPayload['groups'] = [];
  let lonely = 0;
  for (const s of samples) {
    const keys = new Set(picked[s.id] ?? []);
    if (keys.size === 0) continue;
    const clusters = clusterPhotos(s.images).filter((c) => keys.has(photoKey(c[0])));
    if (clusters.length < 2) { lonely += 1; continue; }
    groups.push({ event_id: s.id, urls: [...new Set(clusters.flat().map((p) => p.url))] });
  }
  return { groups, lonely };
}
